import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import polyfill from "@excalidraw/excalidraw/polyfill";
import { registerSW } from "virtual:pwa-register";

import { CanvaschoolApp } from "./canvaschool/CanvaschoolApp";

import "../excalidraw-app/sentry";

polyfill();
window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();
// Every URL enters the authenticated service; the anonymous Excalidraw app
// (rooms, shared links, Firebase storage) is not mounted.
root.render(
  <StrictMode>
    <CanvaschoolApp />
  </StrictMode>,
);
